

export class EmployeeDocumentDto implements IEmployeeDocumentDto {
    id!: number | undefined;
    documentTypeId!: number;
    documentUri!: string | undefined;
    extension!: string | undefined;
    createdOn!: Date | undefined;

    constructor(data?: IEmployeeDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentTypeId = _data["documentTypeId"];
            this.documentUri = _data["documentUri"];
            this.extension = _data["extension"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EmployeeDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentTypeId"] = this.documentTypeId;
        data["documentUri"] = this.documentUri;
        data["extension"] = this.extension;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IEmployeeDocumentDto {
    id: number | undefined;
    documentTypeId: number;
    documentUri: string | undefined;
    extension: string | undefined;
    createdOn: Date | undefined;
}

